'use strict';

import $ from 'jquery';
import companiesSlideshow from './person-slideshow';
import ajax from './ajax';

class AccordionModel {
    constructor(letter) {
        this.currPage = 1;
        this.pattern = letter;
        this.finished = false;
        this.alreadyCalledSlideIndex = {};
        const mcpRegex = /most-creative-people|mcp/;
        this.windowLocationPath = window.location.pathname;
        this.isMCP = mcpRegex.test(this.windowLocationPath);
    }

    get(slideIndex) {
        // console.log('!! ', this.finished);
        // if (!this.finished) {
        const promise = ajax(this.buildURI(), {
            method: 'GET'
        });
        this.currPage += 1;
        if (slideIndex) {
            this.alreadyCalledSlideIndex[slideIndex] = true;
        }
        return promise;
        // }
    }

    buildURI() {
        let base = `https://api.fastcompany.com/v1/packages/person/search/pattern?page=${this.currPage}&rows_per_page=60&pattern=${this.pattern}`;
        if (this.isMCP) {
            base += `&mcp1000=1`;
        }
        return base;
    }

    setFinishedState(reason) {
        this.finished = true;
    }
}

class AccordionCollectionView {
    constructor() {
        this.$companiesIndexLetters = $('.companies-index-letter');
        this.$companiesContainer = $('.companies-container');
        this.$arrow = $('.arrow');
        this.$letterPreview = $('.letter-preview');
    }

    init() {
        // console.log("THIS IS RIGHT ", this.$companiesIndexLetters);
        this.$companiesIndexLetters.one('click', (e) => this.initializeSlideshow(e));
        this.$companiesIndexLetters.click(this.changeArrow);
    }
    populateSlides(data, e) {
        var groups = [],
            currentGroup = [],
            len = data.rows.length,
            i;

        for (i = 0; i < len; i++) {
            let currentItem = data.rows[i];

            if ((i % 10) === 0 && i > 0) {
                groups.push(currentGroup);
                currentGroup = [];
            }
            currentGroup.push(`
                <div class="list-company">
                    <div class="company">
                        <h4 class="company-name">
                            <a href="/person/${currentItem.url}">${currentItem.full_name}</a>
                        </h4>
                    </div>
                </div>
            `);
        }
        groups.push(currentGroup);

        // Let's join the data every 3 groups which is a slideshow page
        var slideShow = [],
            slideShowPage = [];

        for (i = 0; i < groups.length; i++) {
            if ((i % 3) === 0 && i > 0) {
                slideShow.push(slideShowPage);
                slideShowPage = [];
            }
            slideShowPage.push(groups[i]);
        }

        slideShow.push(slideShowPage);
        let finalMarkup = ``;
        // For testing...how to create the html
        for (i = 0; i < slideShow.length; i++) {
            var page = slideShow[i];

            var column1 = page[0] ? page[0].join('') : '';
            var column2 = page[1] ? page[1].join('') : '';
            var column3 = page[2] ? page[2].join('') : '';

            // console.log(e);
            // console.log($(e.currentTarget).find('.companies-list'));
            finalMarkup += `
                <div class="companies-column-container slide">
                    <div class="companies-column">${column1}</div>
                    <div class="companies-column">${column2}</div>
                    <div class="companies-column">${column3}</div>
                </div>
            `;

        }
        // console.log(e.currentTarget);
        if (!$(e.currentTarget).hasClass('slick-initialized')) {
            $(e.currentTarget).find('.companies-list').append(finalMarkup);
        }
         // console.log(finalMarkup);
        return finalMarkup;
    }
    buildSlides(e, model) {
        return (data) => {
            this.populateSlides(data, e);

            return companiesSlideshow(e.currentTarget.id, model, this);

        };
    }
    initializeSlideshow(e) {
        let letter = $(e.currentTarget).data('letter');
        if (letter) {
            let encodededLetter = encodeURIComponent(letter);
            let accordionModel  = new AccordionModel(encodededLetter);
            if (!accordionModel.finished) {
                accordionModel
                .get()
                .then(this.buildSlides(e, accordionModel))
                .catch(function (error) {
                    accordionModel.setFinishedState();
                    console.error(error); // eslint-disable-line no-console
                });
            }
        }

    }

    changeArrow(e) {
        if ($(e.target).is('a') || $(e.target).parent().is('a') || $(e.target).is('button') || !$(e.currentTarget).data('letter')) {
            return;
        }

        $(e.currentTarget).find('.companies-container').slideToggle(300);
        $(e.currentTarget).find('.arrow').toggleClass('arrow-down');
        $(e.currentTarget).find('.letter-preview').toggleClass('letter-preview-hidden');
    }
}

export default new AccordionCollectionView();
